import { Select } from "antd";
import { t } from "i18next";
import "./index.scss";

function InputSearch({ onSearch, valueSearchSerial }) {
  const dropdownStyle = {
    display: "none",
  };
  return (
    <div className="form-input-search-by-serial">
      <Select
        mode="tags"
        allowClear={true}
        value={valueSearchSerial}
        placeholder={t("serialExportDetail.searchSerialIMEI")}
        onChange={onSearch}
        className="select-tag-search"
        dropdownStyle={dropdownStyle}
        defaultOpen={false}
        size="small"
      />
    </div>
  );
}

export default InputSearch;
